<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>
                <b-link :to="{name: 'countries.browse'}">
                    &ldquo;{{ country.name }}&rdquo;
                </b-link>
                /
                <b-link :to="{name: 'regions.browse', params: {countryId: country.id}}">
                    &ldquo;{{ region.name }}&rdquo;
                </b-link>
                /
                districts
            </h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new district"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Districts</h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit district'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" :region="region" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" v-model="editingDistrict" v-if="editingDistrict"
                   :district="editingDistrict" :region="region" />
    </div>
</template>

<script>
import findRegionQuery from '@views/Districts/Browse/queryFindRegion.graphql';
import listDistrictsQuery from '@views/Districts/Browse/queryListDistricts.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseDistricts',
  props: {
    regionId: {
      required: true,
    },
  },
  apollo: {
    region: {
      query: findRegionQuery,
      update: data => data.findRegion,
      variables() {
        return {
          input: {
            id: this.regionId,
          },
        };
      },
    },
    districts: {
      query: listDistrictsQuery,
      variables() {
        return {
          input: {
            region_id: this.regionId,
            include_deleted: true,
          },
        };
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.districts = data.filterDistricts.data;
          this.pagination.total = data.filterDistricts.meta.total;
        }
      },
    },
  },
  data() {
    return {
      districts: [],
      region: null,
      editingDistrict: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'District',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    country() {
      return this.region.country;
    },
    tableData() {
      return (this.districts || []).map(item => ({
        ...item,
      }));
    },
  },
  methods: {
    showEditDialog(district) {
      this.editingDistrict = district;
    },
    closeEditDialog() {
      this.editingDistrict = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
